import React, { useEffect } from "react";
import { Modal } from "react-bootstrap";
import PropTypes from "prop-types";
import {
  commaSeperator,
  convertMilesToKm,
  getInitials
} from "../../../utils/methods";
import { Border } from "../../common/Manager/style";
import { closeIcon } from "../../../utils/icons";
import LazyImage from "../../common/LazyImage/LazyImage";
import { ImageUrl } from "../../../utils/constants";
import { HeaderContainer,  RecognitionCard,RecognitionsContainer,StyledBody,StyledModal, } from "../../Manager/Dashboard/style";
import { NameInitials } from "../../Manager/styles";
import { t } from "i18next";

const TeamChallengePopup = ({
  showModal,
  headerText,
  onClose,
  team,
  teamRank,
  challenge
}) => {


  useEffect(() => {
  }, []);

  const DistanceUnit = localStorage.getItem('DISTANCE');
  return (
    <>
      <StyledModal
        id="recognition-popup-1"
        show={showModal}
        onHide={onClose}
        dialogClassName={"info-popup"}
        backdropClassName="drop-back"
        
        isHeight={"none"}
      >
        <Modal.Header>
          <HeaderContainer id="recognition-popup-header">
            <div>
              <span id="header-text" className="header-text">{headerText}</span>
            </div>
            <div id="close" style={{ cursor: "pointer" }} onClick={onClose}>
              {closeIcon("#F37A65", 14, 14)}
            </div>
          </HeaderContainer>
        </Modal.Header>
        <div style={{ padding: "0px 16px" }}>
          <Border style={{ margin: "20px 0px 0px", padding: "0px 16px" }} />
        </div>
        <StyledBody>
          <RecognitionsContainer
            id="recognition-container-1"
            style={{ maxHeight: "555.5px", overflowY: "scroll" }}
          >
            <div id="top-card" className="top-card">
              <div id="col-one" className="col-one">
                {(team?.logo !== "profile-Image/default.png" && team?.logo ) ? (
                  <LazyImage
                    style={{
                      width: "60px",
                      height: "60px",
                      borderRadius: "50px",
                    }}
                    src={ImageUrl + "/" + team?.logo}
                  />
                ) : (
                  <NameInitials>{getInitials(team?.name)}</NameInitials>
                )}
                <div id="mid-col" className="mid-col">
                  <div>
                    <span className="user-name">{team.name}</span>
                  </div>
                  <div>
                    <span className="user-name">{team?.team_contribution} {challenge?.event_type === "Total Steps" ? t("steps") : challenge?.event_type === "Total Distance" ? DistanceUnit === "KILOMETER"?"Km":  t("Miles") : t("Calories")}</span>
                  </div>
                </div>
              </div>
              <div id="total-count" className="total-count">
                <span>{teamRank}{teamRank === 1 ? "st" : teamRank === 2 ? "nd" : teamRank === 3 ? "rd" : "th"}</span>
              </div>
            </div>

            {team?.team_users?.length ? team?.team_users?.map((user, index) => (
              <RecognitionCard  id="user-card-1" key={index} background={user?.bg_color}>
                <div className="col-one-new">
                  {user?.profile_image !== "profile-Image/default.png" ? (<LazyImage
                    div={"image"}
                    style={{
                      width: "48px",
                      height: "48px",
                      background: user?.bg_color,
                      borderRadius:"50%",
                    }}
                    src={ImageUrl + "/" + user?.profile_image}
                  />):<NameInitials>{getInitials(user?.name)}</NameInitials>}
                  <span className="name" title={user?.name}>{user?.name}</span>
                </div>
                <div className="team-challenge-count">
                  {/* <span>{user?.steps}</span> */}
                  <span>{challenge?.event_type === "Total Steps" ? commaSeperator(user?.steps) : challenge?.event_type === "Total Distance" ?DistanceUnit === "KILOMETER"?commaSeperator(convertMilesToKm(Math.round(user?.distance) || 0)) :commaSeperator(Math.round(user?.distance) || 0) : commaSeperator(Math.round(user?.calories))} {challenge?.event_type === "Total Steps" ? t("steps") : challenge?.event_type === "Total Distance" ? DistanceUnit === "KILOMETER"?"Km":  t("Miles") : t("Calories")}
                  </span>
                </div>
              </RecognitionCard>
            )):<span className="no-data">No members found</span>}
            {/* {Recognitions.length > 5 && (
              <ShowMore
                onClick={() => {
                  Recognitions.length === RecognitionData.length
                    ? setRecognitionData(Recognitions.slice(0, 5))
                    : setRecognitionData(Recognitions);
                }}
                style={{
                  cursor: "pointer",
                  marginTop: "10px",
                  textAlign: "center",
                  color: "#184A61",
                }}
              >
                {Recognitions.length === RecognitionData.length
                  ? "Show Less"
                  : "Show More"}
              </ShowMore>
            )} */}
          </RecognitionsContainer>
        </StyledBody>
      </StyledModal>
    </>
  );
};

TeamChallengePopup.propTypes = {
  showModal: PropTypes.bool.isRequired,
  headerText: PropTypes.string,
  onClose: PropTypes.func,
  team: PropTypes.object,
  teamRank:PropTypes.number,
  challenge:PropTypes.object
};

export default TeamChallengePopup;
